import { SuccessPayload } from '../store/common-actions';

export interface News {
  id: string;
  dateTime: number;
  dateTimeText?: string;
  headline: string;
  source: string;
  url: string;
  summary: string;
  related: string;
  symbols: Array<string>;
  image: string;
  lang: string;
  hasPaywall: boolean;
}

export type NewsData = SuccessPayload & {
  totalCount: number
  totalPageCount: number
  pageNumber: number
  pageSize: number
  data: News[]
  resultCode?: number
}

export type NewsGWResponse = {
  symbol?: string,
  accessId: string,
  traceIdentifier: string,
}

export interface RootNewsResponse {
  newsArticles: NewsData;
  resultCode: number;
  messageType: string;
  traceIdentifier: string;
}

export const DEFAULT_PAGE_SIZE = 5;
